export enum DataViewEnum {
    Card,
    List
}